module.exports = __webpack_public_path__ + "static/img/kongtiao-tongfeng.2180038d.png";